import Category from "./components/Category";
import Pages from "./pages/Pages";
import { BrowserRouter } from "react-router-dom"; // surround our app with it to allow app to function around pages
import Search from "./components/Search";
import styled from "styled-components";
import { Link } from "react-router-dom";
// import { GiKnifeFork } from "react-icons/gi";
import { IoMdFitness } from "react-icons/io";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Nav>
          <IoMdFitness />
          <Logo to={"/"}>DM Fitness Tracker</Logo>
        </Nav>
        <Search />
        <Category />
        <Pages />
      </BrowserRouter>
    </div>
  );
}

const Logo = styled(Link)`
  text-decoration: none;
  font-size: 1.5rem;
  font-weight: 400;
  font-family: "Lobster Two", cursive;
  color: orange;
`;

const Nav = styled.div`
  padding: 2rem 0rem 1rem 0rem;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  svg {
    font-size: 2rem;
    color: orange;
  }
`;

export default App;
